// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_mo-1";
export var rowFirst = "_mo-3";
export var rowLast = "_mo-5";
export var rowMiddle = "_mo-4";
export var ticketListScroll = "_mo-2";
export var ticketStack = "_mo-0";